import axios from "axios";

const apiClient = axios.create({
  timeout: 15000,
  headers: {
    "Content-Type": "application/json",
  },
});

 function makeApiRequest(
  url,
  jsonBody,
  authKey,
  onResponse,
  onError
) {
  apiClient
    .post(url, jsonBody ?? {}, {
      headers: {
        Authkey: authKey,
        clientSubscriberID: "10027",
      },
    })
    .then((response) => {
     // console.log("Response Code:", response.status);
     // console.log("Response Message:", response.data);
      onResponse(
        response.data
      );
    })
    .catch((error) => {
      const err =
        error.response
          ? new Error(
              `HTTP ${error.response.status}: ${JSON.stringify(
                error.response.data
              )}`
            )
          : error;

      console.error("API Request Exception", err.message);
      onError(err);
    });
}


 function callApi(
  url,
  jsonBody,
  authKey,
  onResponse,
  onError
) {
 // console.log("authkey api", authKey);

  apiClient
    .post(url, jsonBody ?? {}, {
      headers: {
        Authorization: authKey,
      },
    })
    .then((response) => {
     // console.log("Response Code:", response.status);
    //  console.log("Response Message:", response.data);
      onResponse(
        response.data
      );
    })
    .catch((error) => {
      const err =
        error.response
          ? new Error(
              `HTTP ${error.response.status}: ${JSON.stringify(
                error.response.data
              )}`
            )
          : error;

      console.error("API Request Exception", err.message);
      onError(err);
    });
}


export { makeApiRequest, callApi };